import { ReactElement, cloneElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { IFormField } from '@vivli/shared/infrastructure/interface';

interface BaseControlledFormFieldComponentProps extends IFormField {
    children: ReactElement;
    name: string;
}

export const BaseControlledFormFieldComponent = ({ name, children, ...props }: BaseControlledFormFieldComponentProps) => {
    const { control } = useFormContext();
    const { onChange: onChangeFromCaller, ...propsWithoutOnChange } = props;

    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: props.required }}
            render={({ field, fieldState }) => {
                const { invalid, error } = fieldState;

                //the form's own handler runs first so it always records the change; a caller's
                //handler runs after, so it can still overwrite the value it just recorded
                const handleChange = (...event: any[]) => {
                    field.onChange(...event);
                    onChangeFromCaller?.(event[0]);
                };

                //this is where value, onChange, etc. are passed in
                return cloneElement(children, {
                    ...field,
                    ...propsWithoutOnChange,
                    onChange: handleChange,
                    invalid,
                    checked: field.value,
                    error: props.error || error?.message
                });
            }}
        />
    );
};
